import React from 'react';
import videojs from 'video.js';

export default class VideoPlayer extends React.Component {
  componentDidMount() {
    let options = this.props;
    options.sources[0] = this.props.src;
    // instantiate video.js
    this.player = videojs(this.videoNode, options, function onPlayerReady() {
    });
  }
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }
  render() {
    return (
      <div data-vjs-player className={this.props.className !== undefined ? this.props.className : null}>
        <video ref={node => (this.videoNode = node)} className={`${this.props.className } video-js`} />
      </div>
    );
  }
}
